var frameStyle = "position: absolute; bottom: 10px; right: 10px;"
var ifrm;

document.addEventListener("DOMContentLoaded", function (event) {
    window.addEventListener('message', receiver, false);
    loadIFrame();
});

function loadIFrame() {
    ifrm = document.getElementById("child_frame");
    // console.log('child_frame_div', child_frame_div);
    // ifrm = document.createElement('iframe');
    // ifrm.setAttribute('id', 'ifrm');
    // child_frame_div.appendChild(ifrm);
    // ifrm.setAttribute("style", frameStyle);
    // ifrm.setAttribute('src', 'http://localhost:4300');
    // setFrameSize(500,600);
}

function setFrameSize(width, height) {
    // ifrm = document.getElementById('ifrm');
    console.log('ifrm', ifrm);
    ifrm.width = width;
    ifrm.height = height;
}

function receiver(e) {
    // document.getElementById('message').value = e.data;
    // if(!e.origin?.includes("agentvizion.com)")){
    //     console.log("invalid origin", e.origin);
    //     return;
    // }
    let data;
    try {
        data = JSON.parse(e.data);
    } catch (e) {
        console.log("error", e);
        return;
    }
    if(!data.frameId){
        console.log("invalid frameId id")
    }
    if (data.operation == 'Frame size') {
        setFrameSize(data.data.width, data.data.height);
    }
    if (data.operation == 'tokenExpiry') {
        localStorage.removeItem("_t");
        localStorage.removeItem("userTabInfo");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("activeTabId");
        localStorage.removeItem("activeSubTab");
        window.location.href = '/login';
    }
    if (data.operation == 'localstorage') {
        let localStorageData =  ['localStorage', data.key, localStorage.getItem(data.key)];
        update_child(localStorageData, data.frameId);
    }
    if(data.operation == 'origin'){
        let originurl = window.origin;
        update_child(['origin', originurl], data.frameId);
    }
    // console.log("message", e, data);
}

function update_child(message, frameId) {
    // var el = document.getElementsByTagName('iframe')[0];
    var el = document.getElementById(frameId);
    try{
        message = message;
    } catch(e){
        console.log("error", e);
    }
    el?.contentWindow.postMessage(message, '*');
}
